import DeclensionNouns from "../../../../Common/DeclensionNouns";
import { Util } from "../../../../Common/Util";
import Vocabulary from "../../../../Common/Vocabulary";

export class Intercity {
    constructor({ page, getRoutes }) {
        this.$page = page;
        this._getRoutes = getRoutes;

        this.$interCityElement = this.$page.find('.toggle_checkbox.interCity__item');

        this.$intercityCheckbox = this.$interCityElement.find('#only_intercity');

        this.$intercityCheckbox.on('change', this.toggleInterCity.bind(this));

        this._numberOfTrains = 0;

        this._onlyIntercity = false;
    }

    renderIntercityCheckbox() {
        const routes = this._getRoutes();
        const intercityTrain = routes.find(train => train.intercity);

        if (intercityTrain) return this.$interCityElement.show();

        return this.$interCityElement.hide();
    }

    toggleInterCity(event) {
        this._onlyIntercity = this.$intercityCheckbox.prop('checked');
        this.renderIntercityTrain();
    }

    renderIntercityTrain() {
        const routes = this._getRoutes();
        routes.forEach(route => {
            const routeElement = $(this.$page).find(`.railway_results_item[data-routeid="${route.number}"]`);

            if (this._onlyIntercity && route.intercity) {
                routeElement.show();
            } else {
                routeElement.hide();
            }

            if (!this._onlyIntercity) {
                routeElement.show();
            }
        });

        this._numberOfTrains = $(this.$page.find('.railway_results_item:not([style*="display: none"])')).length;
        $(this.$page).find('.flights_count').html(`<span class="number_flights">${this._numberOfTrains}</span> ${DeclensionNouns(this._numberOfTrains, Vocabulary[Util.getCurrentLang()].routes_count.split('|'))} ${Vocabulary[Util.getCurrentLang()].found}`);
    }

    isIntercity() {
        return this._onlyIntercity;
    }
}